import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Container as CommonContainer } from 'assets/Common/Layout';
import {
  Button as CommonButton,
  ButtonIcon as CommonButtonIcon
} from 'assets/Common/Button';

export const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  display: block;
  z-index: 100;
  width: 100%;
  background: ${props => props.theme.background};
  box-shadow: ${props => props.theme.boxShadow};
  padding: 15px 0;

  ${Media.lg`
    padding: 10px 0;
  `}

  ${Media.md`
    padding: 5px 0;
  `}

  ${Media.sm`
    padding: 2px 0;
  `}
`;

export const Container = styled.div`
  ${CommonContainer}
`;

export const Box = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;

  ${Media.md`
    grid-template-columns: 1fr;
  `}
`;

export const Content = styled.div`
  display: block;
  width: 100%;
`;

export const Text = styled.p`
  display: block;
  max-width: 100%;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: default;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Menu = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-gap: 10px;

  ${Media.md`
    grid-template-columns: 1fr 1fr;
  `}

  ${Media.sm`
    grid-template-columns: 1fr;
  `}
`;

export const Button = styled.button`
  ${CommonButton}
`;

export const ButtonLink = styled(RouterLink)`
  ${CommonButton}
`;

export const ButtonIcon = styled.i`
  ${CommonButtonIcon}
`;
